/// Links públicos de busca e rota do Maps (api=1): não pedem chave e abrem no navegador ou no app.

export interface MapAddress {
    streetName?: string | null;
    number?: string | null;
    district?: string | null;
    city?: string | null;
    uf?: string | null;
    postalCode?: string | null;
}

/// "Rua X, 123 - Bairro, Cidade - UF, 01234-567"; vazio sem rua nem cidade (só CEP erra o mapa).
export const addressQuery = (address: MapAddress): string => {
    const clean = (value?: string | null) => (value ?? '').trim();

    const street = [clean(address.streetName), clean(address.number)].filter(Boolean).join(', ');
    const city = [clean(address.city), clean(address.uf)].filter(Boolean).join(' - ');

    if (!street && !clean(address.city)) return '';

    const cep = clean(address.postalCode).replace(/\D/g, '');

    return [
        [street, clean(address.district)].filter(Boolean).join(' - '),
        city,
        cep.length === 8 ? `${cep.slice(0, 5)}-${cep.slice(5)}` : '',
    ]
        .filter(Boolean)
        .join(', ');
};

export const mapsSearchUrl = (query: string) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

/// Sem origem, o Maps usa a localização de quem abriu: o que o vendedor quer ao sair para a visita.
export const mapsDirectionsUrl = (query: string) =>
    `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(query)}`;
